package org.gymly.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/** Reglas de contraseña. Iguales al backend (PasswordPolicy): se aplican al crear o cambiar la contraseña. */
object PasswordRules {
    const val MIN_LENGTH = 8

    /** Reglas que aún no cumple la contraseña; vacía = válida. */
    fun unmet(password: String): List<String> = buildList {
        if (password.length < MIN_LENGTH) add("Al menos $MIN_LENGTH caracteres")
        if (password.none { it.isLetter() }) add("Al menos una letra")
        if (password.none { it.isDigit() }) add("Al menos un número")
    }
}

private val RuleOk = Color(0xFF2E7D32)

/** Lista de condiciones debajo de un campo de contraseña nueva; cada una se marca al cumplirse. */
@Composable
fun PasswordRulesHint(password: String, muted: Color = Color(0xFF6B7280), modifier: Modifier = Modifier) {
    val pending = PasswordRules.unmet(password)
    val rules = listOf(
        "Al menos ${PasswordRules.MIN_LENGTH} caracteres" to (password.length >= PasswordRules.MIN_LENGTH),
        "Al menos una letra" to password.any { it.isLetter() },
        "Al menos un número" to password.any { it.isDigit() },
    )
    Column(modifier.padding(top = 6.dp)) {
        Text("La contraseña debe tener:", color = muted, fontSize = 12.sp)
        Spacer(Modifier.height(2.dp))
        rules.forEach { (label, met) ->
            Row {
                Text(
                    if (met) "✓ " else "• ",
                    color = if (met) RuleOk else muted,
                    fontSize = 12.sp,
                )
                Text(label, color = if (met) RuleOk else muted, fontSize = 12.sp)
            }
        }
        if (password.isNotEmpty() && pending.isNotEmpty()) {
            Spacer(Modifier.height(2.dp))
            Text(
                "Falta: " + pending.joinToString(", ").lowercase(),
                color = muted,
                fontSize = 12.sp,
            )
        }
    }
}
